import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { officesActions } from '../../../application/actions/offices';

import api from '../../api';

const apiOffices = api(process.env.REACT_APP_OFFICES_API);

export function* fetchOffices() {
  try {
    const { data } = yield call(apiOffices.get, 'v1/consultar');

    if (data) yield put(officesActions.fetchOfficesSuccess({ offices: data.items }));
    else yield put(officesActions.fetchOfficesError());
  } catch (err) {
    yield put(officesActions.fetchOfficesError());
  }
}

export function* watchFetchOffices() {
  yield takeLatest(officesActions.fetchOffices.type, fetchOffices);
}
/* istanbul ignore next */
export default function* officesSaga() {
  yield spawn(watchFetchOffices);
}
